export interface ITableHeader {
  prop: string
  name: string
  checkboxValue?: string
  width?: number
}

export interface ITableFilter {
  columnDef: string
  value: string
}

export interface ITableAction {
  actions: string[]
  data: any[]
  rowsIndexes: number[]
  checked?: boolean
  offset?: number
  sortOptions?: ISortOptions
}

export interface ITableActionIcon {
  value: string
  icon?: string
  buttonLabel?: string
  checkbox?: boolean
  checkboxValue?: boolean
  tooltip?: string
  style?: {
    color?: string
    background?: string
    fontSize?: string
    fontWeight?: string
  }
}

export interface ITableBadge {
  prop: string
  values: IBadgeValue[]
}

interface IBadgeValue {
  value?: string | boolean
  parsedValue?: string
  class: string
  iconName?: string
}

export interface ISortOptions {
  columnDef: string
  sortDirection: SortDirection
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export interface TableConfig {
  tableOffset: number
  tableLimit: number
  tableCount: number
}

export interface Meta {
  totalItems: number
  itemCount: number
  itemsPerPage: number
  totalPages: number
  currentPage: number
}
